import { css } from '@emotion/react'
import { Cell, Grid, HeadingSection, InfoLabel } from 'bold-ui'
import { RastreioCancerPerguntaDbEnum } from 'graphql/types.generated'

import { convertDataPreventivoLocalDateToString } from './utils-citopatologico'

interface CitopatologicoSectionProps {
  questoesRespondidas: Map<RastreioCancerPerguntaDbEnum, string>
  questionario: Partial<Record<RastreioCancerPerguntaDbEnum, string>>
  title: string
}

export function CitopatologicoSection(props: Readonly<CitopatologicoSectionProps>) {
  const { questoesRespondidas, questionario, title } = props

  const entries = (Object.keys(questionario) as RastreioCancerPerguntaDbEnum[])
    .filter((questao) => questoesRespondidas.has(questao))
    .map((questao) => [questao, questoesRespondidas.get(questao)!] as const)
  if (entries.length === 0) return null

  const { grid } = createStyles()

  return (
    <>
      <HeadingSection level={4} vSpace={2} title={title} />
      <Grid style={grid}>
        {entries.map(([questao, resposta]) => (
          <Cell key={questao} size={6}>
            <InfoLabel title={questionario[questao]!}>
              {questao === RastreioCancerPerguntaDbEnum.PERGUNTA_CITO_01_04
                ? convertDataPreventivoLocalDateToString(resposta)
                : resposta}
            </InfoLabel>
          </Cell>
        ))}
      </Grid>
    </>
  )
}

const createStyles = () => ({
  grid: css`
    width: 100%;
  `,
})
